import HeroMedia from './HeroMedia';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'styles/components/HeroSection.css';
import { FaTasks, FaStar } from 'react-icons/fa';

// Hvis videoen ligger i src/media/flytteguide.mp4, kan du importere direkte:
// import flytteguideVideo from '../media/flytteguide.mp4';

const HeroSection = ({ statistics, content, demoEnvironment = false, showCompletedTaskCount = false, showReviewCount = false }) => {
  const navigate = useNavigate();

  return (
    <div className="hero-redesign">
      <div className="hero-overlay"></div>
      
      <HeroMedia content={content} />
      
      <div className="hero-content-wrapper">
        {demoEnvironment && <span className="hero-test-label" title="Opgaver, anmeldelser og tal på denne side er testdata">Testmiljø</span>}
        {(showCompletedTaskCount || showReviewCount) && statistics && <div className="hero-stats-pills">
          {showCompletedTaskCount && Number.isSafeInteger(statistics.completedTasks) && statistics.completedTasks >= 0 && <span className="hero-stat-pill"><FaTasks /> {statistics.completedTasks} afsluttede opgaver</span>}
          {showReviewCount && Number.isSafeInteger(statistics.reviews) && statistics.reviews >= 0 && <span className="hero-stat-pill"><FaStar /> {statistics.reviews} anmeldelser</span>}
        </div>}

        <h1 className="hero-headline">Den nemmeste vej til professionel transport</h1>
        <p className="hero-subheadline">
          Få en fast pris med det samme, eller indhent tilbud fra verificerede vognmænd.
        </p>

        <div className="hero-ctas">
          <button className="hero-cta-primary" onClick={() => navigate('/create-task')}>
            Opret opgave gratis
          </button>
          <button className="hero-cta-secondary" onClick={() => window.scrollTo({ top: window.innerHeight * 0.8, behavior: 'smooth' })}>
            Læs mere
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
